import ReviewsElfsight from "@/components/ReviewsElfsight";
import useDocumentMeta from "@/lib/useDocumentMeta";

export default function ReviewsPage() {
    useDocumentMeta({
        title: "Отзиви · Konstantin Mobile — Какво казват клиентите ни",
        description:
            "Прочетете отзивите на нашите клиенти. Над 700 доволни клиенти, проверена история на всеки автомобил, безкомпромисно качество.",
        path: "/reviews",
    });
    return (
        <main data-testid="reviews-page" className="pt-24">
            <ReviewsElfsight />
        </main>
    );
}
